export default __webpack_public_path__ + "static/media/ConnectModelsOverlay.779efbaa.svg";